import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 2.361a9.639 9.639 0 1 1 0 19.278A9.639 9.639 0 0 1 12 2.36zm.83 8.128H9.464v1.347h2.02v4.33h-2.02v1.347h5.388v-1.347H12.83v-5.677zm-.747-3.768a1.238 1.238 0 1 0 0 2.475 1.238 1.238 0 0 0 0-2.475z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }